module.exports = __webpack_public_path__ + "img/8.601a0508.png";